import React, { useState, useEffect, useRef } from "react";
import NavBar, { infoUtente, loadNav } from "../../visualComponents/NavBarManager.js";
import { useNavigate } from "react-router-dom";
import { ArrowUpAZ, ArrowDownAZ, Pen, Trash2, History, X } from "lucide-react";
import Loader from "../../visualComponents/Loader.js";
import Tooltip from "../../components/Tooltip.js";

let isLoading = false;

const PopUpErrFile = ({ isVisible, setIsVisible, errorData }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        if (isVisible && errorData.length > 0) {
            setData(errorData);
        }
    }, [errorData, isVisible]);

    useEffect(() => {
        if (isVisible && data.length === 0) {
            alert("Tutti gli errori sono stati corretti");
            setIsVisible(false);
            window.location.reload(true);
        }
    }, [data]);


    const closeModal = () => {
        if (window.confirm("Sei sicuro di voler chiudere la finestra? Perderai i dati non salvati.")) {
            window.location.reload(true);
        }
    };

    const ignoreError = async (codice) => {
        if (window.confirm("Sei sicuro di voler ignorare questo errore?")) {
            setData(data.filter(d => d.data[0] !== codice));
        }
    };

    const ignoreAllError = async () => {
        if (window.confirm("Sei sicuro di voler ignorare tutti gli errori?")) {
            window.location.reload(true);
        }
    };

    const addTipologia = async (index) => {
        const codice = data[index].data[0];
        const descrizione = data[index].data[1];
        const durata = data[index].data[2];
        try {
            isLoading = true;
            const response = await fetch("/addTipologia", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    CodiceDominio: infoUtente["CodiceDominio"],
                    Codice: codice,
                    Descrizione: descrizione,
                    Durata: Number(durata)
                }),
            });

            if (response.status === 500) {
                const data = await response.json();
                alert(data.error);
                console.log(data.error);
            } else {
                setData(data.filter(d => d.data[0] !== codice));
                isLoading = false;
            }
        } catch (error) {
            alert("Errore nell'aggiunta della tipologia");
            console.log(error);
        }
    };


    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 rounded-lg p-6 w-100 max-w-[90vw] text-black dark:text-white">
                <div className="flex justify-between items-center mb-6">
                    <h2 className="text-xl font-bold">ERRORI NEL FILE</h2>
                    <Tooltip content="Chiudi">
                        <button className="text-red-500" onClick={closeModal}>
                            <X size={24} />
                        </button>
                    </Tooltip>
                </div>
                <div>
                    <div className="grid grid-cols-5 gap-4">
                        <div className="col-span-4 bg-gray-400 dark:bg-gray-600 rounded-lg grid grid-cols-4 p-2 font-bold text-center divide-x divide-black dark:divide-white">
                            <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                <p className="text-[2vw] md:text-base flex items-center justify-self-center">Codice</p>
                            </div>
                            <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                <p className="text-[2vw] md:text-base flex items-center justify-self-center">Descrizione</p>
                            </div>
                            <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                <p className="text-[2vw] md:text-base flex items-center justify-self-center">Durata Manutezione</p>
                            </div>
                            <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                <p className="text-[2vw] md:text-base flex items-center justify-self-center">Errore</p>
                            </div>
                        </div>
                        <div></div>
                    </div>
                    <div className="overflow-y-auto h-[30vh] mt-2">
                        {data.map((d, index) => (
                            <div className="grid grid-cols-5 gap-4">
                                <div
                                    key={index}
                                    className={`col-span-4 text-center rounded-lg mt-2 mb-2 grid grid-cols-4 p-2 divide-x divide-black dark:divide-white bg-gray-300 dark:bg-gray-500`}
                                >

                                    <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <input type="text" value={d.data[0]} className="text-[2vw] md:text-base flex items-center justify-self-center rounded bg-gray-300 dark:bg-gray-500 border-2 border-gray-400 dark:border-gray-600 px-1" onChange={(e) => {
                                            setData(data.map((el, i) => {
                                                if (index === i) {
                                                    const newData = [...el.data];
                                                    newData[0] = e.target.value;
                                                    return { ...el, data: newData };
                                                }
                                                return el;
                                            }));
                                        }} />
                                    </div>
                                    <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <input type="text" value={d.data[1]} className="text-[2vw] md:text-base flex items-center justify-self-center rounded bg-gray-300 dark:bg-gray-500 border-2 border-gray-400 dark:border-gray-600 px-1" onChange={(e) => {
                                            setData(data.map((el, i) => {
                                                if (index === i) {
                                                    const newData = [...el.data];
                                                    newData[1] = e.target.value;
                                                    return { ...el, data: newData };
                                                }
                                                return el;
                                            }));
                                        }} />
                                    </div>
                                    <div className="grid grid-cols-1 md:flex md:items-center md:justify-center">
                                        <input type="text" value={d.data[2]} className="text-[2vw] md:text-base flex items-center justify-self-center rounded bg-gray-300 dark:bg-gray-500 border-2 border-gray-400 dark:border-gray-600 px-1" onChange={(e) => {
                                            setData(data.map((el, i) => {
                                                if (index === i) {
                                                    const newData = [...el.data];
                                                    newData[2] = e.target.value;
                                                    return { ...el, data: newData };
                                                }
                                                return el;
                                            }));
                                        }} />
                                    </div>
                                    <div className="grid grid-cols-1 md:flex md:items-center md:justify-center p-1">
                                        <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.error}</p>
                                    </div>

                                </div>
                                <div className="flex items-center grid grid-cols-2">
                                    <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-1" onClick={() => ignoreError(d.data[0])}>
                                        Ignora
                                    </button>
                                    <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded ml-1" onClick={() => addTipologia(index)}>
                                        Correggi
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="flex items-center justify-center mt-4">
                        <button className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-1" onClick={() => ignoreAllError()}>
                            Ignora tutto
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const PopUpT = ({ isVisible, setIsVisible, data }) => {
    const [codice, setCodice] = useState("");
    const [descrizione, setDescrizione] = useState("");
    const [durata, setDurata] = useState("");
    const inputRefs = useRef([]);
    const [errorData, setErrorData] = useState([]);
    const [isPopUpErrFileVisible, setIsPopUpErrFileVisible] = useState(false);

    useEffect(() => {
        if (data) {
            setCodice(data["Codice"]);
            setDescrizione(data["Descrizione"]);
            setDurata(data["DurataManutenzione"]);
        }
    }, [data]);

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };

    const resetData = () => {
        setCodice(data ? data["Codice"] : "");
        setDescrizione(data ? data["Descrizione"] : "");
        setDurata(data ? data["DurataManutenzione"] : "");
    };

    const handleConferma = async () => {
        if (data) {
            //modifica
            try {
                isLoading = true;
                const response = await fetch("/aggiornaTipologia", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        Codice: codice,
                        Descrizione: descrizione,
                        Durata: durata,
                        CodiceVecchio: data["Codice"]
                    }),
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    resetData();
                    isLoading = false;
                }

            } catch (error) {
                alert("Errore nella modifica della tipologia");
                console.log(error);
            }
        } else {
            //aggiungi
            try {
                isLoading = true;
                const response = await fetch("/addTipologia", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        Codice: codice,
                        Descrizione: descrizione,
                        Durata: Number(durata)
                    }),
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    resetData();
                    isLoading = false;
                }
            } catch (error) {
                alert("Errore nell'aggiunta della tipologia");
                console.log(error);
            }
        }
        window.location.reload(true);
    };

    const handleImport = async () => {
        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".csv";
        fileInput.click();
        fileInput.onchange = (event) => {
            const file = event.target.files[0];
            if (!file) return;
            const reader = new FileReader();
            reader.onload = async function (event) {

                const text = event.target.result;
                const rows = text.split("\n").map(row => row.split(",").map(cell => cell.replace(/"/g, "")));
                if (rows.length < 2) {
                    alert("File non valido");
                    return;
                }
                rows.shift();

                let tErrorData = [];

                isLoading = true;

                for (let index = 0; index < rows.length; index++) {
                    const row = rows[index];
                    // console.log(`Row ${index + 1}: ${row.join(", ")}`);
                    const data = row[0].split(";");

                    const check = checkCodice(data[0], false);
                    if (check !== "Codice valido") {
                        tErrorData.push({ data: data, error: check });
                        continue;
                    }

                    try {
                        const response = await fetch("/addTipologia", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                CodiceDominio: infoUtente["CodiceDominio"],
                                Codice: data[0],
                                Descrizione: data[1],
                                Durata: Number(data[2])
                            }),
                        });

                        if (response.status === 500) { // Verifica se il server ha risposto con errore
                            const data = await response.json();
                            tErrorData.push({ data: data, error: data.error });
                            console.error(`Errore nella riga ${index + 1}: ${data.error}`);
                        }

                    } catch (error) {
                        tErrorData.push(data);
                        console.error(`Errore nella riga ${index + 1}:`, error);
                    }
                }


                isLoading = false;

                if (tErrorData.length > 0) {
                    console.log(tErrorData);
                    setErrorData(tErrorData);
                    setIsPopUpErrFileVisible(true);
                }
                else {
                    window.location.reload(true);
                }
            };
            reader.onerror = function () {
                console.error("Errore durante la lettura del file CSV");
            };

            reader.readAsText(file);
        }
    };

    const handleExport = () => {
        if (codice === "" || descrizione === "" || durata === "") {
            alert("Compilare tutti i campi");
            return;
        }

        const data = [
            ["Codice", "Descrizione", "Durata Manutenzione (mesi)"],
            [codice, descrizione, durata]
        ];
        const filename = "Export_tiplogia.csv";

        // Crea il contenuto del CSV
        const csvContent = data
            .map(row => row.map(cell => `"${cell}"`).join(";"))
            .join("\n"); // Unisci le righe con newline

        // Crea un blob con il contenuto CSV
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        // Crea un link per scaricare il file
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute("download", filename);

        // Aggiungi e clicca il link per forzare il download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    const checkCodice = async (e, alt) => {
        if (data && e === data["Codice"]) return;
        try {
            const response = await fetch("/checkCodiceTipologia", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Codice: e }),
            });


            if (response.status === 500) {
                const data = await response.json();
                if (alt === true)
                    alert(data.error);
                console.log(data.error);
                return data.error;
            } else {
                if (response.status === 401) {
                    if (alt === true)
                        alert("Codice già esistente");
                    setCodice(data ? data["Codice"] : "");
                    return "Il codice deve essere univoco";
                }
                return "Codice valido";
            }
        } catch (error) {
            if (alt === true)
                alert("Errore nel controllo del codice");
            console.log(error);
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-4">
                    <h2 className="text-xl font-bold justify-self-center">{data ? "Modifica Tipologia" : "Aggiungi Tipologia"}</h2>
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <div className='flex justify-center'>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleImport}>
                            IMPORT
                        </button>
                    </div>
                    <div className='flex justify-center'>
                        <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleExport}>
                            EXPORT
                        </button>
                    </div>
                </div>
                <div>
                    <div className="grid grid-cols-2 mb-2 mt-4">
                        <p>Codice: </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={codice}
                            onChange={(e) => setCodice(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 0)}
                            ref={(el) => (inputRefs.current[0] = el)}
                            onBlur={(e) => checkCodice(e.target.value, true)}
                        />
                    </div>
                    <div className="grid grid-cols-2 mb-2">
                        <p>Descrizione: </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={descrizione}
                            onChange={(e) => setDescrizione(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={(el) => (inputRefs.current[1] = el)}
                        />
                    </div>
                    <div className="grid grid-cols-2 mb-2">
                        <p>Durata Manutenzione: (mesi) </p>
                        <input
                            type="number"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={durata}
                            onChange={(e) => setDurata(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 2)}
                            ref={(el) => (inputRefs.current[2] = el)}
                        />
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
            <PopUpErrFile isVisible={isPopUpErrFileVisible} setIsVisible={setIsPopUpErrFileVisible} errorData={errorData} />
        </div>
    );
};

const PopUpO = ({ isVisible, setIsVisible, data }) => {
    const [operazione, setOperazione] = useState("");
    const [stato, setStato] = useState("");
    const inputRefs = useRef([]);

    useEffect(() => {
        if (data) {
            setOperazione(data["Descrizione"]);
            setStato(data["StatoRisultante"]);
        }
    }, [data]);

    const closeModal = () => {
        resetData();
        setIsVisible(false);
    };

    const resetData = () => {
        setOperazione(data ? data["Descrizione"] : "");
        setStato(data ? data["StatoRisultante"] : "");
    };

    const handleConferma = async () => {
        if (data) {
            //modifica
            try {
                isLoading = true;
                const response = await fetch("/aggiornaOperazione", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        ID: data["ID"],
                        Descrizione: operazione,
                        Stato: stato
                    }),
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    resetData();
                    isLoading = false;
                }
            } catch (error) {
                alert("Errore nella modifica dell'operazione");
                console.log(error);
            }
        } else {
            //aggiungi
            try {
                isLoading = true;
                const response = await fetch("/addOperazione", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        CodiceDominio: infoUtente["CodiceDominio"],
                        Descrizione: operazione,
                        Stato: stato
                    })
                });

                if (response.status === 500) {
                    const data = await response.json();
                    alert(data.error);
                    console.log(data.error);
                } else {
                    resetData();
                    isLoading = false;
                }
            } catch (error) {
                alert("Errore nell'aggiunta dell'operazione");
                console.log(error);
            }
        }
        window.location.reload(true);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Enter") {
            e.preventDefault(); // Evita il comportamento predefinito del form
            const nextInput = inputRefs.current[index + 1];
            if (nextInput) {
                nextInput.focus(); // Passa al campo successivo
            }
        }
    };

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 back">
            <div className="bg-white dark:bg-gray-800 text-black dark:text-white rounded-lg p-6 w-100 max-w-[90vw]">
                <div className="flex justify-center items-center mb-6">
                    <h2 className="text-xl font-bold justify-self-center">{data ? "Modifica Operazione" : "Aggiungi Operazione"}</h2>
                </div>
                <div>
                    <div className="grid grid-cols-2 mb-2">
                        <p>Operazione: </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={operazione}
                            onChange={(e) => setOperazione(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 0)}
                            ref={(el) => (inputRefs.current[0] = el)}
                        />
                    </div>
                    <div className="grid grid-cols-2 mb-2">
                        <p>Stato: </p>
                        <input
                            type="text"
                            className="rounded bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 px-1"
                            value={stato}
                            onChange={(e) => setStato(e.target.value)}
                            onKeyDown={(e) => handleKeyDown(e, 1)}
                            ref={(el) => (inputRefs.current[1] = el)}
                        />
                    </div>
                </div>
                <div className='mt-3 grid grid-cols-2'>
                    <button
                        onClick={closeModal}
                        className="mr-1 rounded-lg py-2 px-4 bg-red-500 hover:bg-red-700 text-white font-bold"
                    >
                        Annulla
                    </button>
                    <button
                        onClick={handleConferma}
                        className="ml-1 rounded-lg py-2 px-4 bg-green-500 hover:bg-green-700 text-white font-bold"
                    >
                        Conferma
                    </button>
                </div>
            </div>
        </div>
    );
};

const TableRowT = ({ data }) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare questa tipologia?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaTipologia', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], Codice: data["Codice"] })
            });

            if (response.status === 200) {
                isLoading = false;
                window.location.reload(true);
            };
        } catch (error) {
            alert("Operazione fallita, riprova più tardi.");
            console.log(error);
        }

    };

    return (
        <div className="grid grid-cols-5 gap-1 md:gap-4 mt-2">
            <div></div>
            <div className="col-span-3 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-3 p-4 text-center break-words">
                <div>{data["Codice"]}</div>
                <div>{data["Descrizione"]}</div>
                <div>{data["DurataManutenzione"]}</div>
            </div>
            <div className="flex items-center gap-1 md:gap-4 ">
                {data["Obsoleto"] ? null : (
                    <>
                        <Tooltip content="Modifica">
                            <button className="text-blue-500" onClick={() => setIsVisible(true)}>
                                <Pen size={24} />
                            </button>
                        </Tooltip>
                        <Tooltip content="Elimina">
                            <button className="text-red-500" onClick={handleElimina}>
                                <Trash2 size={24} />
                            </button>
                        </Tooltip>
                    </>
                )}
            </div>
            <PopUpT isVisible={isVisible} setIsVisible={setIsVisible} data={data} />
        </div>
    );
};

const TableRowO = ({ data }) => {
    const [isVisible, setIsVisible] = useState(false);

    const handleElimina = async () => {
        if (!window.confirm("Sei sicuro di voler eliminare questa operazione?")) return;
        try {
            isLoading = true;
            const response = await fetch('/eliminaOperazione', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"], ID: data.ID })
            });

            if (response.status === 200) {
                isLoading = false;
                window.location.reload(true);
            };
        } catch (error) {
            alert("Operazione fallita, riprova più tardi.");
            console.log(error);
        }

    };

    return (
        <div className="grid grid-cols-4 gap-1 md:gap-4 mt-2">
            <div></div>
            <div className="col-span-2 bg-gray-300 dark:bg-gray-500 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 text-center break-words">
                <div>{data["Descrizione"]}</div>
                <div>{data["StatoRisultante"]}</div>
            </div>
            <div className="flex items-center gap-1 md:gap-4 ">
                {
                    data["ID"] !== 1 ? (
                        <>
                            {data["Obsoleto"] ? null : (
                                <>
                                    <Tooltip content="Modifica">
                                        <button className="text-blue-500" onClick={() => setIsVisible(true)}>
                                            <Pen size={24} />
                                        </button>
                                    </Tooltip>
                                    <Tooltip content="Elimina">
                                        <button className="text-red-500" onClick={handleElimina}>
                                            <Trash2 size={24} />
                                        </button>
                                    </Tooltip>
                                </>
                            )}

                        </>
                    ) : null
                }

            </div>
            <PopUpO isVisible={isVisible} setIsVisible={setIsVisible} data={data} />
        </div >
    );
};

const MagazzinoManager = () => {
    const navigate = useNavigate();
    const [indexTabellaT, setIndexTabellaT] = useState([
        { value: "Codice", dbCode: "Codice", ascending: true, filter: "text" },
        { value: "Descrizione", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Durata Manutenzione (mesi)", dbCode: "DurataManutenzione", ascending: true, filter: "text" }
    ]);
    const [indexTabellaO, setIndexTabellaO] = useState([
        { value: "Operazione", dbCode: "Descrizione", ascending: true, filter: "text" },
        { value: "Stato", dbCode: "StatoRisultante", ascending: true, filter: "text" }
    ]);
    const [filtersT, setFiltersT] = useState({
        Codice: "",
        Descrizione: "",
        DurataManutenzione: ""
    });
    const [filtersO, setFiltersO] = useState({
        Descrizione: "",
        StatoRisultante: ""
    });
    const [dataT, setDataT] = useState([]);
    const [viewDataT, setViewDataT] = useState([]);
    const [dataO, setDataO] = useState([]);
    const [viewDataO, setViewDataO] = useState([]);
    const [archiveT, setArchiveT] = useState(false);
    const [archiveO, setArchiveO] = useState(false);
    const [isVisibleT, setIsVisibleT] = useState(false);
    const [isVisibleO, setIsVisibleO] = useState(false);

    useEffect(() => {
        onload();
    }, []);

    useEffect(() => {
        setViewDataT(dataT.filter((d) => d.value["Obsoleto"] === archiveT));
    }, [dataT]);

    useEffect(() => {
        setViewDataO(dataO.filter((d) => d.value["Obsoleto"] === archiveO));
    }, [dataO]);



    const onload = async () => {
        //getInfoUtente
        try {
            isLoading = true;

            await loadNav();

            //loadTipologie
            const r2 = await fetch("/getTipologie", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
            });

            const rd2 = await r2.json();

            if (r2.status === 500) {
                alert(rd2.error);
                console.log(rd2.error);
                navigate("/dashManager");
            } else {
                setDataT(rd2.map((d) => ({ value: d })));

                //loadOperazioni
                const r3 = await fetch("/getOperazioni", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ CodiceDominio: infoUtente["CodiceDominio"] }),
                });

                const rd3 = await r3.json();

                if (r3.status === 500) {
                    alert(rd3.error);
                    console.log(rd3.error);
                    navigate("/dashManager");
                } else {
                    isLoading = false;
                    setDataO(rd3.map((d) => ({ value: d })));
                }

            }
        } catch (error) {
            alert("Errore nel caricamento delle informazioni utente");
            console.log(error);
            navigate("/dashManager");
        }
    };

    useEffect(() => {
        let newData = [...dataT];
        for (const key in filtersT) {
            if (filtersT[key] !== "") {
                newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filtersT[key].toLowerCase()) : null));
            }
        };
        setViewDataT(newData.filter((d) => d.value["Obsoleto"] === archiveT));
    }, [filtersT]);

    useEffect(() => {
        let newData = [...dataO];
        for (const key in filtersO) {
            if (filtersO[key] !== "") {
                newData = newData.filter((d) => (d.value[key] !== null ? d.value[key].toString().toLowerCase().includes(filtersO[key].toLowerCase()) : null));
            }
        };
        setViewDataO(newData.filter((d) => d.value["Obsoleto"] === archiveO));
    }, [filtersO]);

    const sortByColumnT = (column) => {
        setIndexTabellaT((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabellaT.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewDataT];

        newData.sort((a, b) => {
            if (a.value[column] > b.value[column]) return isAscending ? -1 : 1;
            if (a.value[column] < b.value[column]) return isAscending ? 1 : -1;
            return 0;
        });

        setViewDataT(newData);
    };

    const sortByColumnO = (column) => {
        setIndexTabellaO((prevIndexTabella) =>
            prevIndexTabella.map((d) =>
                d.dbCode === column ? { ...d, ascending: !d.ascending } : d
            )
        );
        const isAscending = indexTabellaO.find((d) => d.dbCode === column)?.ascending;
        let newData = [...viewDataO];

        newData.sort((a, b) => {
            if (a.value[column] > b.value[column]) return isAscending ? -1 : 1;
            if (a.value[column] < b.value[column]) return isAscending ? 1 : -1;
            return 0;
        });

        setViewDataO(newData);
    };

    const handleAddTipologia = () => {
        setIsVisibleT(true);
    };

    const handleAddOperazione = () => {
        setIsVisibleO(true);
    };

    const handleArchiveT = () => {
        const newArchive = !archiveT;
        setArchiveT(newArchive);
        let newData = [...dataT];
        newData = newData.filter((d) => d.value["Obsoleto"] === newArchive);
        setViewDataT(newData);
    };

    const handleArchiveO = () => {
        const newArchive = !archiveO;
        setArchiveO(newArchive);
        let newData = [...dataO];
        newData = newData.filter((d) => d.value["Obsoleto"] === newArchive);
        setViewDataO(newData);
    };

    return (
        <div className="min-h-screen bg-white dark:bg-gray-800">
            <NavBar page="MAGAZZINO" />
            {isLoading && <Loader />}
            <div className="p-4 bg-white dark:bg-gray-800 text-black dark:text-white divide-y-2 md:divide-y-0 md:divide-x-2 divide-black dark:divide-white grid grid-cols-1 md:grid-cols-7">
                <div className="items-center justify-center pr-0 md:pr-4 col-span-4 mt-14">
                    <p className="font-bold text-xl justify-self-center text-center">TIPOLOGIA</p>
                    <div className='flex justify-center'>
                        <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleAddTipologia}>
                            Aggiungi Tipologia
                        </button>
                    </div>
                    <div id="tabella">
                        <div className="grid grid-cols-5 gap-4 mt-4">
                            <div></div>
                            <div className="col-span-3 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-3 p-4 font-bold text-center">
                                {
                                    indexTabellaT.map((d, index) => (
                                        <div key={index} onClick={() => sortByColumnT(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                            <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                            </button>
                                        </div>
                                    ))
                                }
                            </div>
                            <div></div>
                        </div>
                        <div className="grid grid-cols-5 gap-4 mt-2">
                            <div></div>
                            <div className="col-span-3 rounded-lg grid grid-cols-3 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                                {
                                    indexTabellaT.map((d, index) => (
                                        <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 2 ? "pl-2" : "px-2"}`}>
                                            <input
                                                type={d.filter}
                                                placeholder={d.value}
                                                value={filtersT[d.dbCode]}
                                                className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                                onChange={(e) => setFiltersT({ ...filtersT, [d.dbCode]: e.target.value })}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                            <div className='flex items-center'>
                                <Tooltip content="Archivio">
                                    <button className={!archiveT ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchiveT}>
                                        <History size={24} />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        <div className="overflow-y-auto h-[50vh]">
                            {viewDataT.map((d, index) => (
                                <TableRowT key={index} data={d.value} />
                            ))}
                        </div>
                    </div>
                    <PopUpT isVisible={isVisibleT} setIsVisible={setIsVisibleT} />
                </div>
                <div className="items-center justify-center pl-0 md:pl-4 col-span-3 mt-14">
                    <p className="font-bold text-xl justify-self-center">OPERAZIONI</p>
                    <div className='flex justify-center'>
                        <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4" onClick={handleAddOperazione}>
                            Aggiungi Operazione
                        </button>
                    </div>
                    <div id="tabella">
                        <div className="grid grid-cols-4 gap-4 mt-4">
                            <div></div>
                            <div className="col-span-2 bg-gray-400 dark:bg-gray-600 divide-x divide-black dark:divide-white rounded-lg grid grid-cols-2 p-4 font-bold text-center">
                                {
                                    indexTabellaO.map((d, index) => (
                                        <div key={index} onClick={() => sortByColumnO(d.dbCode)} className="hover:cursor-pointer grid grid-cols-1 md:flex md:items-center md:justify-center">
                                            <p className="text-[2vw] md:text-base flex items-center justify-self-center">{d.value}</p>
                                            <button className="ml-2 text-gray-500 dark:text-gray-700 justify-self-center">
                                                {d.ascending ? <ArrowDownAZ size={24} /> : <ArrowUpAZ size={24} />}
                                            </button>
                                        </div>
                                    ))
                                }
                            </div>
                            <div></div>
                        </div>
                        <div className="grid grid-cols-4 gap-4 mt-2">
                            <div></div>
                            <div className="col-span-2 rounded-lg grid grid-cols-2 p-4 font-bold text-center divide-x divide-black dark:divide-white">
                                {
                                    indexTabellaO.map((d, index) => (
                                        <div key={index} className={`flex items-center justify-center ${index === 0 ? "mr-2" : index === 1 ? "pl-2" : "px-2"}`}>
                                            <input
                                                type={d.filter}
                                                placeholder={d.value}
                                                value={filtersO[d.dbCode]}
                                                className="text-[2vw] md:text-base rounded bg-gray-100 dark:bg-gray-300 border-2 border-gray-200 dark:border-gray-400 p-1 md:px-1 text-center w-full"
                                                onChange={(e) => setFiltersO({ ...filtersO, [d.dbCode]: e.target.value })}
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                            <div className='flex items-center'>
                                <Tooltip content="Archivio">
                                    <button className={!archiveO ? "text-yellow-700" : "text-yellow-300"} onClick={handleArchiveO}>
                                        <History size={24} />
                                    </button>
                                </Tooltip>
                            </div>
                        </div>
                        {viewDataO.map((d, index) => (
                            <TableRowO key={index} data={d.value} />
                        ))}
                    </div>
                    <PopUpO isVisible={isVisibleO} setIsVisible={setIsVisibleO} />
                </div>
            </div>
        </div>
    );
};

export default MagazzinoManager;